"use strict";
"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Body } from "../Body/Body.js";
import { clsx } from "../../styles/clsx.js";
import { utilClasses } from "../../styles/utility.js";
import classes from "./Anchor.module.css.js";
import { useComponents } from "../ComponentsContext/useComponents.js";
const Anchor = forwardRef(
  ({ className, ...props }, ref) => {
    const components = useComponents();
    const Link = components.Link;
    if (!props.href && !props.onClick) {
      return /* @__PURE__ */ jsx(Body, { as: "span", ...props, ref });
    }
    if (props.href) {
      return /* @__PURE__ */ jsx(
        Body,
        {
          ...props,
          className: clsx(classes.base, utilClasses.focusVisible, className),
          as: Link,
          ref
        }
      );
    }
    return /* @__PURE__ */ jsx(
      Body,
      {
        as: "button",
        ...props,
        className: clsx(classes.base, utilClasses.focusVisible, className),
        ref
      }
    );
  }
);
Anchor.displayName = "Anchor";
export {
  Anchor
};
